import { RootState } from '@dis/redux'

export const selectNotifications = (state: RootState) => state.centralNotification
